import { useEffect, useRef, useState } from 'react'

export function useIsVisible<T extends HTMLElement>() {
  const ref = useRef<T>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        setIsVisible(entry.isIntersecting)
      })

      observer.observe(ref.current)
      return () => {
        observer.disconnect()
      }
    }
  }, [ref.current])

  return { ref, isVisible }
}
